@if (visible) {
  <div class="canvas-pointage canvas-operation-reelle"
    [attr.inert]="historiqueVisible ? '' : null"
    [attr.aria-hidden]="historiqueVisible ? 'true' : null">
    <div class="canvas-pointage__overlay" (click)="annuler.emit()"></div>
    <div class="canvas-pointage__panel canvas-operation-reelle__panel" role="dialog" aria-modal="true">
      <div class="canvas-operation-reelle__header">
        <div>
          <h3>
            {{ operation ? "Modifier l'opération planifiée" : "Ajouter une opération planifiée" }}
          </h3>
        </div>
        <button type="button" class="canvas-operation-reelle__close" aria-label="Fermer le formulaire"
          (click)="annuler.emit()">
          &times;
        </button>
      </div>
      <form [formGroup]="form" (ngSubmit)="submit()" class="formulaire canvas-operation-reelle__form">
        @if (erreur) {
          <p class="canvas-operation-reelle__erreur" role="alert">{{ erreur }}</p>
        }
        <section class="canvas-operation-reelle__section">
          <div class="canvas-operation-reelle__section-header">
            <div>
              <h4>Informations générales</h4>
              <p>Libellé, type et montant planifié</p>
            </div>
            @if (operation) {
              <button #historiqueBouton type="button"
                class="canvas-operation-reelle__badge edition-planifiee__historique" (click)="ouvrirHistorique()">
                Voir l’historique
              </button>
            }
            @if (!operation) {
              <span class="canvas-operation-reelle__badge canvas-operation-reelle__badge--info">Création</span>
            }
          </div>
          <div class="canvas-operation-reelle__grid">
            <label class="canvas-operation-reelle__field canvas-operation-reelle__field--full">
              Libellé
              <input #libelleInput type="text" formControlName="libelle" />
            </label>
            <label class="canvas-operation-reelle__field">
              Type
              <select formControlName="type">
                <option value="ENTREE">Entrée</option>
                <option value="SORTIE">Sortie</option>
              </select>
            </label>
            <label class="canvas-operation-reelle__field">
              Montant
              <input #montantInput type="text" appMontant formControlName="montant" />
            </label>
            <label class="canvas-operation-reelle__field">
              Date de début
              <input type="date" formControlName="dateDebut" />
            </label>
            <label class="canvas-operation-reelle__field categorie-select">
              Catégorie
              <div class="categorie-select__row">
                <select formControlName="categorie">
                  <option value="">Aucune</option>
                  @for (cat of categories; track cat) {
                    <option [value]="cat.nom">{{ cat.nom }}</option>
                  }
                </select>
                <button type="button" class="btn-ajout-categorie" aria-label="Ajouter une catégorie"
                (click)="ajouterCategorie.emit()">+</button>
              </div>
            </label>
          </div>
        </section>
        <section class="canvas-operation-reelle__section">
          <div class="canvas-operation-reelle__section-header">
            <div>
              <h4>Calendrier &amp; répétition</h4>
              <p>Durée, jour d'exécution et étalement</p>
            </div>
          </div>
          <div class="canvas-operation-reelle__grid">
            <label class="canvas-operation-reelle__field">
              Durée (mois)
              <input type="number" formControlName="nombreDeMois" />
            </label>
            <label class="canvas-operation-reelle__field">
              Jour du mois
              <input type="number" formControlName="jourDuMois" min="1" max="31" />
            </label>
            <label class="canvas-operation-reelle__field">
              Périodicité
              <select formControlName="periodicite">
                <option [ngValue]="1">Tous les mois</option>
                <option [ngValue]="2">Tous les 2 mois</option>
                <option [ngValue]="3">Tous les 3 mois</option>
                <option [ngValue]="6">Tous les 6 mois</option>
                <option [ngValue]="12">Tous les ans</option>
              </select>
            </label>
            <label class="canvas-operation-reelle__field canvas-operation-reelle__field--checkbox">
              <span>Étalement / Paiement multiple</span>
              <div class="checkbox">
                <input type="checkbox" formControlName="estEtalee" />
                Étaler la dépense (paiement en plusieurs fois)
              </div>
            </label>
          </div>
          @if (etalementActif) {
            <div class="canvas-operation-reelle__subcard">
              <div class="canvas-operation-reelle__grid">
                <label class="canvas-operation-reelle__field">
                  Nombre de mensualités
                  <input type="number" min="2" formControlName="nombreMensualites" />
                </label>
                <label class="canvas-operation-reelle__field">
                  Montant initial
                  <input type="text" appMontant formControlName="montantInitial" />
                </label>
              </div>
              <small>Le montant mensuel est ajusté automatiquement. La dernière mensualité recevra le reste.</small>
            </div>
          }
        </section>
        <section class="canvas-operation-reelle__section">
          <div class="canvas-operation-reelle__section-header">
            <div>
              <h4>Provision &amp; destination</h4>
              <p>Provisionnement, moyen de paiement et virement</p>
            </div>
          </div>
          <div class="canvas-operation-reelle__grid">
            <label class="canvas-operation-reelle__field canvas-operation-reelle__field--checkbox">
              <span>Provision</span>
              <div class="checkbox">
                <input type="checkbox" formControlName="provision" />
                Activer la provision
              </div>
            </label>
            <label class="canvas-operation-reelle__field valeur-restante"
              [class.valeur-restante--masquee]="!form.get('provision')?.value">
              Valeur restante
              <input type="text" appMontant min="0" formControlName="valeurRestante"
                [disabled]="!form.get('provision')?.value" />
              </label>
              <label class="canvas-operation-reelle__field canvas-operation-reelle__field--moyen">
                Moyen de paiement
                <select formControlName="moyenPaiement">
                  <option [ngValue]="null">Aucun</option>
                  @for (m of moyensPaiement; track m) {
                    <option [ngValue]="m.value">{{ m.label }}</option>
                  }
                </select>
              </label>
              @if (form.get('moyenPaiement')?.value === 'CHEQUE') {
                <label class="canvas-operation-reelle__field"
                  >
                  Numéro de chèque
                  <input type="text" formControlName="numeroCheque" aria-required="true"
                    [attr.aria-invalid]="form.controls.numeroCheque.invalid && form.controls.numeroCheque.touched ? 'true' : null"
                    aria-describedby="edition-planifiee-erreur-cheque" />
                    @if (form.controls.numeroCheque.invalid && form.controls.numeroCheque.touched) {
                      <small id="edition-planifiee-erreur-cheque" class="canvas-operation-reelle__erreur" role="alert"
                        >
                        Le numéro de chèque est obligatoire.
                      </small>
                    }
                  </label>
                }
                @if (form.get('moyenPaiement')?.value === 'VIREMENT') {
                  <label class="canvas-operation-reelle__field canvas-operation-reelle__field--checkbox"
                    >
                    <div class="checkbox">
                      <input type="checkbox" formControlName="virementProgramme" />
                      Virement programmé sur la banque
                    </div>
                  </label>
                }
                @if (form.get('moyenPaiement')?.value === 'VIREMENT') {
                  <label class="canvas-operation-reelle__field"
                    >
                    Compte destination
                    <div class="destination-toggle">
                      <label>
                        <input type="radio" formControlName="typeDestination" value="interne" />
                        Compte existant
                      </label>
                      <label>
                        <input type="radio" formControlName="typeDestination" value="externe" />
                        Compte externe
                      </label>
                    </div>
                  </label>
                }
                @if (form.get('moyenPaiement')?.value === 'VIREMENT' && form.get('typeDestination')?.value === 'interne') {
                  <label class="canvas-operation-reelle__field"
                    >
                    &nbsp;
                    <select formControlName="compteDestinationId">
                      <option [ngValue]="null">Sélectionner un compte</option>
                      @for (c of comptesDisponibles; track c) {
                        <option [ngValue]="c.id">{{ c.nom }}</option>
                      }
                    </select>
                  </label>
                }
                @if (form.get('moyenPaiement')?.value === 'VIREMENT' && form.get('typeDestination')?.value === 'externe') {
                  <label class="canvas-operation-reelle__field"
                    >
                    &nbsp;
                    <input type="text" formControlName="compteDestinationExterne" placeholder="Nom du compte externe" />
                  </label>
                }
              </div>
            </section>
            <div class="canvas-operation-reelle__actions edition-planifiee__actions">
              @if (operation) {
                <div class="edition-planifiee__suppression"
                  [class.edition-planifiee__suppression--confirmation]="confirmerSuppr">
                  @if (!confirmerSuppr) {
                    <button type="button" class="btn-supprimer" (click)="demanderSuppr()">🗑 Supprimer</button>
                  }
                  @if (confirmerSuppr) {
                    <span class="confirm-suppr">Confirmer la suppression ?</span>
                    <button type="button" class="btn-confirmer-suppr" (click)="confirmerSupprDef()">Oui, supprimer</button>
                    @if (operation.groupeRef || (groupeIds?.length ?? 0) > 1) {
                      <button type="button" class="btn-confirmer-suppr btn-confirmer-suppr--groupe"
                        (click)="confirmerSupprGroupe()"
                        title="Supprimer toutes les occurrences de cette mensualisation">
                        Supprimer toute la mensualisation
                      </button>
                    }
                    <button type="button" class="btn-secondaire" (click)="annulerSuppr()">Annuler la suppression</button>
                  }
                </div>
              }
              <div class="edition-planifiee__validation">
                <button type="button" class="btn-secondaire" (click)="annuler.emit()">
                  Annuler
                </button>
                <button type="submit">
                  {{ operation ? "Mettre à jour" : "Ajouter" }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <app-popup-historique-planifiee
        [visible]="historiqueVisible"
        [operation]="operation"
        (fermer)="fermerHistorique()"
      ></app-popup-historique-planifiee>
    }
